<template>
  <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
    <h6 class="check-text-center">Agendamentos</h6>

    <v-btn class="btn-add-modern" @click="directToCreateSchedule(resident_id)">
      <i class="fas fa-calendar-check mr-2"></i>
      <span>Realizar Agendamento</span>
    </v-btn>

    <hr />
    <div class="row">
      <div class="filter-group col-md-6">
        <label class="filter-label">
          <i class="fas fa-calendar-alt filter-icon"></i>
          Data Início
        </label>

        <v-text-field
          v-model="date_init"
          type="date"
          outlined
          dense
          hide-details
          class="modern-input"
          @input="getSchedules"
        />
      </div>

      <div class="filter-group col-md-6">
        <label class="filter-label">
          <i class="fas fa-calendar-check filter-icon"></i>
          Data Fim
        </label>

        <v-text-field
          v-model="date_end"
          type="date"
          outlined
          dense
          hide-details
          class="modern-input"
          @input="getSchedules"
        />
      </div>
    </div>

    <div class="table-section">
      <div class="table-card">
        <b-overlay :show="loading" opacity="0.99" class="loading-overlay">
          <v-data-table
            :headers="headers"
            :items="schedules"
            item-key="id"
            :footer-props="{
              'items-per-page-options': [50, 75, 100],
              'items-per-page-text': 'Mostrar',
            }"
            class="modern-table"
            :no-data-text="'Nenhum agendamento encontrado'"
            :loading-text="'Carregando agendamentos...'"
          >
            <template v-slot:[`item.user_name`]="{ item }">
              <div class="user-cell">
                <div class="user-avatar">
                  <img
                    v-if="item.user_photo_url"
                    :src="item.user_photo_url"
                    :alt="item.user_name"
                    class="user-photo"
                  />
                  <i v-else class="fas fa-user"></i>
                </div>
                <span class="user-name">{{ item.user_name }}</span>
              </div>
            </template>

            <template v-slot:[`item.schedule_type_name`]="{ item }">
              <div class="type-cell">
                <span>{{ item.schedule_type_name }}</span>
              </div>
            </template>

            <template v-slot:[`item.date`]="{ item }">
              <div class="date-cell">
                <div class="date-badge start-badge">
                  <i class="fas fa-calendar-day mr-1"></i>
                  <span>{{ formatDate(item.date, false) }}</span>
                </div>
              </div>
            </template>

            <template v-slot:[`item.time_init`]="{ item }">
              <div class="date-cell">
                <div class="date-badge">
                  <i class="fas fa-clock mr-1"></i>
                  <span>{{ item.time_init || "--" }}</span>
                </div>
              </div>
            </template>

            <template v-slot:[`item.time_end`]="{ item }">
              <div class="date-cell">
                <div class="date-badge">
                  <i class="fas fa-clock mr-1"></i>
                  <span>{{ item.time_end || "--" }}</span>
                </div>
              </div>
            </template>

            <template v-slot:[`item.note`]="{ item }">
              <div class="note-cell">
                <v-btn
                  v-if="item.note && item.note.trim()"
                  class="note-btn"
                  small
                  @click="openNoteModal(item)"
                >
                  <i class="fas fa-sticky-note mr-1"></i>
                  Ver Observação
                </v-btn>
                <div v-else class="no-note">
                  <i class="fas fa-minus text-muted"></i>
                  <span class="text-muted">Sem Observação</span>
                </div>
              </div>
            </template>
          </v-data-table>
        </b-overlay>
      </div>
    </div>

    <b-modal
      id="noteModal"
      size="lg"
      hide-footer
      modal-class="modern-modal"
      no-close-on-backdrop
    >
      <template v-slot:modal-title>
        <div class="modal-title-modern">
          <i class="fas fa-sticky-note mr-2"></i>
          Observação do Agendamento
        </div>
      </template>

      <div class="modal-content-modern" v-if="selectSchedule">
        <div class="note-section">
          <div class="note-header">
            <h4 class="note-title">
              <i class="fas fa-comment-alt mr-2"></i>
              Observação
            </h4>
          </div>
          <div class="note-content-display">
            <div class="note-text-area">
              {{ selectSchedule.note }}
            </div>
          </div>
        </div>

        <div class="modal-actions">
          <v-btn class="btn-close-modal" @click="$bvModal.hide('noteModal')">
            <i class="fas fa-times mr-2"></i>
            Fechar
          </v-btn>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { formatDate } from "../../lib/format";

import api from "../../services/api";

import routes from "../../routes";

import moment from "moment";

export default {
  name: "MenuSchedule",

  data() {
    return {
      loading: false,

      schedules: [],

      selectSchedule: null,

      date_init: moment().startOf("month").format("YYYY-MM-DD"),

      date_end: moment().endOf("month").format("YYYY-MM-DD"),

      headers: [
        {
          text: "Cadastrado por",
          value: "user_name",
        },
        {
          text: "Tipo do Agendamento",
          value: "schedule_type_name",
        },
        {
          text: "Data",
          value: "date",
        },
        {
          text: "Hora de Início",
          value: "time_init",
        },
        {
          text: "Hora Final",
          value: "time_end",
        },
        {
          text: "Observação",
          value: "note",
        },
      ],
    };
  },

  props: {
    resident_id: Number,
  },

  mounted() {
    this.getSchedules();
  },

  methods: {
    formatDate,

    async getSchedules() {
      try {
        this.loading = true;

        const { resident_id, date_init, date_end } = this;

        let params = { resident_id, date_init, date_end };

        const response = await api.get("/schedule/resident", {
          params,
        });

        const { error, schedules } = response.data;

        if (!error) {
          this.schedules = schedules;
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },

    openNoteModal(item) {
      this.selectSchedule = item;

      this.$bvModal.show("noteModal");
    },

    directToCreateSchedule: (resident_id_for_modal) =>
      routes.push({
        name: "schedule",
        query: {
          tab: "check",
          nav: "check",
          resident_id_for_modal,
        },
      }),
  },
};
</script>

<style scoped>
.table-section {
  margin-bottom: 32px;
}

.table-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  overflow: hidden;
}

.loading-overlay {
  border-radius: 16px;
}

/* Table Cell Styling */
.user-cell {
  display: flex;
  align-items: center;
  gap: 12px;
}

.user-avatar {
  width: 32px;
  height: 32px;
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 12px;
}

.user-photo {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
  transition: transform 0.2s ease;
}

.user-name {
  font-weight: 500;
  color: #1e293b;
}

.date-cell {
  display: flex;
  align-items: center;
}

.date-badge {
  display: inline-flex;
  align-items: center;
  padding: 3px 6px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.start-badge {
  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
  color: #059669;
  border: 1px solid #34d399;
}

.note-cell {
  display: flex;
  align-items: center;
  justify-content: center;
}

.note-btn {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 8px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  font-size: 11px !important;
  box-shadow: 0 2px 8px rgba(245, 158, 11, 0.3) !important;
  transition: all 0.3s ease !important;
}

.note-btn:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.4) !important;
}

.no-note {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #9ca3af;
  font-style: italic;
}

/* Table Styling Override */
.modern-table {
  background: transparent !important;
}

.modern-table >>> .v-data-table__wrapper {
  border-radius: 0 !important;
}

.modern-table >>> .v-data-table thead th {
  background-color: #f8fafc !important;
  color: #374151 !important;
  font-weight: 600 !important;
  font-size: 12px !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  border-bottom: 2px solid #e5e7eb !important;
  padding: 16px 12px !important;
}

.modern-table >>> .v-data-table tbody tr:hover {
  background-color: #f8fafc !important;
}

.modern-table >>> .v-data-table tbody td {
  padding: 16px 12px !important;
  border-bottom: 1px solid #f1f5f9 !important;
}

.filter-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.filter-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 4px;
}

.modal-title-modern {
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: 600;
  color: #1e293b;
}

.modal-content-modern {
  padding: 8px 0;
}

.note-section {
  background: white;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  overflow: hidden;
  margin-bottom: 24px;
}

.note-header {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  padding: 16px 20px;
  border-bottom: 1px solid #e5e7eb;
}

.note-title {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
  display: flex;
  align-items: center;
}

.note-title i {
  color: #0f65b0;
}

.note-content-display {
  padding: 20px;
}

.note-text-area {
  background: #f8fafc;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 16px;
  color: #374151;
  font-size: 14px;
  line-height: 1.6;
  white-space: pre-wrap;
  word-wrap: break-word;
  min-height: 100px;
  max-height: 300px;
  overflow-y: auto;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
  border-top: 1px solid #e5e7eb;
}

.btn-close-modal {
  background: transparent !important;
  color: #64748b !important;
  border: 2px solid #e5e7eb !important;
  border-radius: 8px !important;
  padding: 10px 20px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  transition: all 0.3s ease !important;
}

.btn-close-modal:hover {
  background: #f8fafc !important;
  border-color: #cbd5e1 !important;
  color: #374151 !important;
}

.modern-modal >>> .modal-body {
  padding: 24px !important;
}

.btn-add-modern {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;
  margin-left: auto !important;
  display: block !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 12px 24px !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  box-shadow: 0 4px 15px rgba(16, 185, 129, 0.3) !important;
  transition: all 0.3s ease !important;
}

.btn-add-modern:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(16, 185, 129, 0.4) !important;
}
</style>